import { css, drawerClasses, List, styled, SwipeableDrawer } from '@mui/material';

export const SSwipeableDrawer = styled(SwipeableDrawer)(
  () => css`
    .${drawerClasses.paper} {
      padding: 16px;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }
  `,
);

export const SList = styled(List)(
  () => css`
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
  `,
);
